import { object, string } from 'yup'

export const addLowLatencyHostsFormValidationSchema = object().shape({
  displayName: string().trim().required('Name is required'),
  host: string().trim().required('Host is required')
})
